import { Vue, Component, Watch } from "vue-property-decorator";
import { AccessLevel, ApplicationViews } from "@/util/enum";
import { Icon } from "ant-design-vue";
import { VersionGroupModule } from "@/modules/versiongroup";
import ChildNavigation from "@/components/navigation/child-navigation/child-navigation.vue";
import VersionGroupSelect from "@/components/version-group-select/version-group-select.vue";
import EntityUsageModal from "@/views/common-entities/components/entity-usage-modal/entity-usage-modal.vue";
import CommonEntityModal from "@/views/common-entities/components/common-entity-modal/common-entity-modal.vue";
import { CommonEntitiesModule } from "@/modules/common-entities";
import { fmtMsg } from "commonui";
import { CommonEntitiesLocale, CommonLocale } from "@/locales/localeid";
import { Alert } from "ant-design-vue";
import { disabledDueToAccessLevel, getRouteAccessLevel, isAnyVersionSelected } from "@/util/func";
import PageTitle from "@/components/page-title/page-title.vue";

@Component({
	components: {
		Icon,
		Alert,
		EntityUsageModal,
		CommonEntityModal,
		VersionGroupSelect,
		ChildNavigation: ChildNavigation,
		PageTitle
	}
})
export default class CommonPage extends Vue {
	public view = ApplicationViews.CommonEntities;
	private versionGroupModule = VersionGroupModule;
	public CommonEntitiesModule = CommonEntitiesModule;
	public noVersion: boolean = false;
	public commonLocale = CommonLocale;
	public commonEntitiesLocale = CommonEntitiesLocale;
	public accessLevel = AccessLevel;

	created() {
		if (!isAnyVersionSelected()) {
			this.noVersion = true;
		}
	}

	mounted() {
		this.versionGroupModule.setDisabled(false);
	}

	@Watch("versionGroupModule.selectedGsVersion")
	@Watch("versionGroupModule.selectedLsVersion")
	isVersionUpdated() {
		if (isAnyVersionSelected()) {
			this.noVersion = false;
		} else {
			this.noVersion = true;
		}
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	disablePath(path: string) {
		return false;
	}

	get addNew() {
		return fmtMsg(CommonEntitiesLocale.CommonModalAddNew);
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	@Watch("versionGroupModule.selectedGsVersion", { immediate: true })
	@Watch("versionGroupModule.selectedLsVersion", { immediate: true })
	getVersionGroups() {
		CommonEntitiesModule.getVersionGroups();
	}

	addNewCommon() {
		CommonEntitiesModule.setIsEdit(false);
		CommonEntitiesModule.setVisibleModal(true);
	}
}
